import { Translation } from "@cryptors/api-client";

export const getTranslation = (
  translation: Pick<Translation, "value" | "languageCode">[] | undefined | null,
  language = "fr",
) => {
  if (!translation) return null;
  return translation.find((t) => t.languageCode === language);
};
